// extracted by mini-css-extract-plugin
export default {"mirror":"Sidebar_mirror__29Crm","wrapperLogo":"Sidebar_wrapperLogo__W7cNF"};